export class LoadViwUserProfileINModel {
  idUser: number
}